export const ORDER_CHANGE_EVENT = "order-change";
export const AIR_ORDER_CHANGE_EVENT = "air-order-change";

export const CHAT_REFRESH_TARGETS = new Set(["OrderMessage", "AirOrderMessage"]);

export const ORDER_LIST_REFRESH_TARGETS = new Set([
  "OrderCreated",
  "OrderUpdated",
  "OrderStatusChanged",
]);

export const ORDER_DETAIL_REFRESH_TARGETS = new Set([
  "OrderUpdated",
  "OrderStatusChanged",
  "NewOrderBid",
  "TenderExtended",
]);

export const ORDER_HUB_TARGETS = Object.freeze([
  ...ORDER_LIST_REFRESH_TARGETS,
  "NewOrderBid",
  "TenderExtended",
]);

export const AIR_ORDER_LIST_REFRESH_TARGETS = new Set([
  "AirOrderCreated",
  "AirOrderUpdated",
  "AirOrderStatusChanged",
]);

export const AIR_ORDER_DETAIL_REFRESH_TARGETS = new Set([
  "AirOrderUpdated",
  "AirOrderStatusChanged",
  "NewAirOrderBid",
  "TenderExtended",
]);

export const AIR_ORDER_HUB_TARGETS = Object.freeze([
  ...AIR_ORDER_LIST_REFRESH_TARGETS,
  "NewAirOrderBid",
  "TenderExtended",
]);
